import { render, staticRenderFns } from "./admin-video-element.vue?vue&type=template&id=01bcbf7c&scoped=true&"
import script from "./admin-video-element.vue?vue&type=script&lang=js&"
export * from "./admin-video-element.vue?vue&type=script&lang=js&"
import style0 from "./admin-video-element.vue?vue&type=style&index=0&id=01bcbf7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bcbf7c",
  null
  
)

export default component.exports